import { onBeforeUnmount, onMounted, ref } from 'vue'

//AI generated!!! I'm sorry. But I can't be bothered to figure all of this out myself.

const links = [
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: 'anonymous' },
  {
    rel: 'shortcut icon',
    href: 'https://lzp.nl/wp-content/uploads/2022/10/faviconlzp.png',
    type: 'image/x-icon',
  },
  'https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;700&display=swap',
  'https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css',
  'https://cdn.jsdelivr.net/npm/smartwizard@6/dist/css/smart_wizard_all.min.css',
  {
    rel: 'stylesheet',
    href: 'https://cdnjs.cloudflare.com/ajax/libs/tempusdominus-bootstrap-4/5.39.0/css/tempusdominus-bootstrap-4.min.css',
    crossorigin: 'anonymous',
  },
  'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css',
  'https://cdn.datatables.net/v/bs5/jszip-2.5.0/dt-1.13.1/date-1.2.0/sb-1.4.0/b-2.3.3/b-colvis-2.3.3/sr-1.2.0/b-html5-2.3.3/b-print-2.3.3/fh-3.3.1/r-2.4.0/sl-1.5.0/datatables.min.css',
  {
    rel: 'stylesheet',
    href: 'https://cdnjs.cloudflare.com/ajax/libs/jsoneditor/9.10.2/jsoneditor.min.css',
    crossorigin: 'anonymous',
    integrity:
      'sha512-brXxIa/fpMfluh8HUWyrNssKy/H0oRzA0HhmipgfVwbXPamMUTZn1jEsvoGGwJYCRpSx4idujdul4vFwWgPROA==',
    referrerpolicy: 'no-referrer',
  },
  'https://cdn.jsdelivr.net/npm/daterangepicker/daterangepicker.css',
  'https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.6.6/css/flag-icons.min.css',
  'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css',
  '/css/classic.css?version=20',
  '/css/custom-lzp-style.css?version=20',
]

const scripts = [
  { src: 'https://ga.jspm.io/npm:es-module-shims@2.6.2/dist/es-module-shims.js', async: true },
  {
    type: 'importmap',
    text: JSON.stringify({
      imports: {
        'content-disposition': 'https://cdn.jsdelivr.net/npm/content-disposition@0.5.4/+esm',
      },
    }),
  },
  'https://cdn.jsdelivr.net/npm/lodash@4.17.21/lodash.min.js',
  {
    src: 'https://code.jquery.com/jquery-3.6.1.min.js',
    crossorigin: 'anonymous',
    integrity: 'sha256-o88AwQnZB+VDvE9tvIXrMQaPlFFSUTR+nldQm1LuPXQ=',
  },
  {
    src: 'https://cdn.jsdelivr.net/npm/mustache@4.2.0/mustache.min.js',
    crossorigin: 'anonymous',
    integrity: 'sha256-1/0GA1EkYejtvYFoa+rSq4LfM4m5zKI13Z1bQIhI4Co=',
  },
  'https://unpkg.com/feather-icons@4.29.1/dist/feather.min.js',
  'https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js',
  'https://cdn.jsdelivr.net/npm/jquery-sortablejs@latest/jquery-sortable.js',
  'https://cdnjs.cloudflare.com/ajax/libs/proj4js/2.5.0/proj4.js',
  '/static/legacy-js/converter.js?version=3',
  {
    src: 'https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.16/jquery.mask.min.js',
    crossorigin: 'anonymous',
    integrity:
      'sha512-pHVGpX7F/27yZ0ISY+VVjyULApbDlD0/X0rgGbTqCE7WFW5MezNTWG/dnhtbBuICzsd0WQPgpE4REBLv+UqChw==',
    referrerpolicy: 'no-referrer',
  },
  {
    src: 'https://cdn.jsdelivr.net/npm/jquery-validation@1.19.5/dist/jquery.validate.js',
    crossorigin: 'anonymous',
    referrerpolicy: 'no-referrer',
  },
  'https://cdn.jsdelivr.net/npm/i18next@21.6.10/i18next.min.js',
  'https://cdn.jsdelivr.net/npm/jquery-i18next@1.2.1/jquery-i18next.min.js',
  'https://cdn.jsdelivr.net/npm/i18next-browser-languagedetector@6.1.3/i18nextBrowserLanguageDetector.min.js',
  {
    src: 'https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.29.4/moment.min.js',
    crossorigin: 'anonymous',
    referrerpolicy: 'no-referrer',
  },
  'https://cdn.jsdelivr.net/npm/daterangepicker/daterangepicker.min.js',
  'https://cdn.quilljs.com/1.3.6/quill.js',
  'https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js',
  'https://cdn.jsdelivr.net/npm/smartwizard@6/dist/js/jquery.smartWizard.min.js',
  {
    src: 'https://cdnjs.cloudflare.com/ajax/libs/tempusdominus-bootstrap-4/5.39.0/js/tempusdominus-bootstrap-4.min.js',
    crossorigin: 'anonymous',
  },
  {
    src: 'https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/toastr.min.js',
    crossorigin: 'anonymous',
  },
  'https://unpkg.com/alpinejs@3.13.8/dist/cdn.min.js',
  'https://cdn.jsdelivr.net/npm/axios@1.1.2/dist/axios.min.js',
  'https://cdn.jsdelivr.net/npm/apexcharts',
  {
    src: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/js/all.min.js',
    'data-auto-replace-svg': 'nest',
  },
  'https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.6/dist/umd/popper.min.js',
  'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.min.js',
  {
    src: 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.bundle.js',
    crossorigin: 'anonymous',
    integrity:
      'sha512-zO8oeHCxetPn1Hd9PdDleg5Tw1bAaP0YmNvPY8CwcRyUk7d7/+nyElmFrB6f7vg4f7Fv4sui1mcep8RIEShczg==',
    referrerpolicy: 'no-referrer',
  },
  'https://unpkg.com/uuid@8.3.2/dist/umd/uuidv4.min.js',
  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.36/pdfmake.min.js',
  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.36/vfs_fonts.js',
  'https://cdn.datatables.net/v/bs5/jszip-2.5.0/dt-1.13.1/date-1.2.0/sb-1.4.0/b-2.3.3/b-colvis-2.3.3/b-html5-2.3.3/b-print-2.3.3/fh-3.3.1/sr-1.2.0/r-2.4.0/sl-1.5.0/datatables.min.js',
  'https://cdn.datatables.net/colreorder/1.6.2/js/dataTables.colReorder.min.js',
  '/static/legacy-js/datatable-spring-friendly.js?version=3',
  '/static/legacy-js/exceljs.min.js',
  'https://cdnjs.cloudflare.com/ajax/libs/dragula/3.7.3/dragula.min.js',
  'https://cdn.jsdelivr.net/npm/fullcalendar@5.11.3/main.min.js',
  { type: 'module', src: 'https://unpkg.com/ionicons@7/dist/ionicons/ionicons.esm.js' },
  { nomodule: true, src: 'https://unpkg.com/ionicons@7/dist/ionicons/ionicons.js' },
  {
    src: 'https://cdnjs.cloudflare.com/ajax/libs/jsoneditor/9.10.2/jsoneditor.min.js',
    crossorigin: 'anonymous',
    integrity:
      'sha512-jhDajNRbXZ4gJ8SVzcuWTHbgSX66Dh98CwmAkhBHWVuEYVgY8G35rbZuRlQwrOcwEB6z5aYzxUptsSjgTGlCbA==',
    referrerpolicy: 'no-referrer',
  },
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyAnppP05VEb8TqOr9w1hPKqsU7yFQBmwFM&libraries=drawing,places',
  'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js',
  { type: 'module', src: 'https://cdn.jsdelivr.net/npm/content-disposition@0.5.4/+esm' },
  'https://cdn.jsdelivr.net/npm/@stomp/stompjs@7.1.0/bundles/stomp.umd.min.js',
  '/static/legacy-js/submodule-ids.js',
  '/static/legacy-js/export.js',
  '/static/legacy-js/datatable.js',
  '/static/legacy-js/theme.js?version=20',
  '/static/legacy-js/helpers.js?version=20',
  '/static/legacy-js/observers.js',
  { type: 'module', src: '/static/legacy-js/constants.js' },
  '/static/legacy-js/constants-2.js',
]

type Attrs = Record<string, string | boolean>

function create(tag: 'link' | 'script', attrs: Attrs) {
  const { text, ...rest } = attrs
  const element = document.createElement(tag)
  if (tag === 'script') (element as HTMLScriptElement).async = false // set first, so `async: true` can override it
  for (const [key, value] of Object.entries(rest)) {
    if (value !== false) element.setAttribute(key, value === true ? '' : value)
  }
  if (typeof text === 'string') element.textContent = text
  return element
}

function loaded(element: HTMLElement) {
  return new Promise<void>(resolve => {
    element.addEventListener('load', () => resolve(), { once: true })
    element.addEventListener(
      'error',
      () => {
        console.error(
          'Legacy asset failed:',
          element.getAttribute('src') ?? element.getAttribute('href')
        )
        resolve()
      },
      { once: true }
    )
  })
}

const waitable = (element: HTMLElement) =>
  (element.hasAttribute('src') && !element.hasAttribute('nomodule')) ||
  element.getAttribute('rel') === 'stylesheet'

export function useLegacyAssets() {
  const ready = ref(false)
  let added: HTMLElement[] = []

  onMounted(async () => {
    added = [
      ...links.map(asset =>
        create('link', typeof asset === 'string' ? { rel: 'stylesheet', href: asset } : asset)
      ),
      ...scripts.map(asset => create('script', typeof asset === 'string' ? { src: asset } : asset)),
    ]
    const waits = added.filter(waitable).map(loaded)
    document.head.append(...added)
    await Promise.all(waits)
    ready.value = true
  })

  onBeforeUnmount(() => added.forEach(element => element.remove()))
  return { ready }
}
